// Industry-aware Merchandise Store Power Up demo templates.

import { getPowerUpProfile } from "../../../industries/power_up_profiles";

const supplementalProducts = [
  ["Event Logo Hat", "Apparel"],
  ["Reusable Water Bottle", "Drinkware"],
  ["Supporter Tote Bag", "Accessories"],
  ["Event Keepsake Pin", "Collectibles"],
  ["Volunteer Notebook", "Stationery"],
  ["Limited Edition Print", "Collectibles"],
];

const getVariants = (category) => {
  if (category === "Apparel") return ["Small", "Medium", "Large", "XL"];
  if (["Accessories", "Pet Accessories"].includes(category)) {
    return ["Standard", "Premium"];
  }
  return ["Standard"];
};

export const buildStoreDefaults = ({
  industryTemplate = "car_show",
} = {}) => {
  const profileProducts = getPowerUpProfile(industryTemplate).products;
  // Every Store demo needs enough catalog cards to exercise filtering, images,
  // product states, shipping, pickup, and variant selection.
  const pool = [...profileProducts, ...supplementalProducts];
  const limit = 10;

  const products = pool.slice(0, limit).map(([name, category], index) => {
    const productSlug = name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

    return {
      localKey: productSlug,
      productSlug,
      name,
      description: `${name} created for supporters and attendees of this event.`,
      category,
      priceCents: 1200 + (index * 700),
      imageUrl: index % 2 === 0 ? "/images/og-default.png" : "/images/social-share-car-shows.png",
      active: index !== 8,
      featured: index % 3 === 0,
      allowPickup: index % 3 !== 1,
      allowShipping: index % 2 === 0,
      displayOrder: (index + 1) * 10,
      receivedInventory: 0,
      availableInventory: 0,
      soldInventory: 0,
      demoSeed: true,
    };
  });

  const variants = products.flatMap((product, productIndex) =>
    getVariants(product.category).map((variantName, index) => {
      const receivedInventory = variantName === "Standard" ? 25 : 15;
      const reservedInventory = productIndex % 4 === 0 && index === 0 ? 2 : 0;

      return {
        productLocalKey: product.localKey,
        name: variantName,
        // Production Store pages use label for selectors and order lines.
        label: variantName,
        sku: `${product.localKey}-${variantName}`
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, ""),
        priceCents: product.priceCents + (index * 200),
        receivedInventory,
        availableInventory: receivedInventory - reservedInventory,
        soldInventory: 0,
        reservedInventory,
        active: true,
        displayOrder: (index + 1) * 10,
        demoSeed: true,
      };
    })
  );

  return { products, variants };
};
